module.exports = __webpack_public_path__ + "img/learn_title.247dc747.png";